
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
    "parkCode": ["312345"],
"sellBeginTime":"202204150000",
"sellEndTime":"202204160000"
},
            responseCode: {
                "data": {
                    "recordList": [
                        {
                            "carCode": "川A0402领",
                            "code": "test",
                            "couponTypeStr": "时间券",
                            "faceValue": "100",
                            "grantTime": "20210608104815",
                            "grantUserName": "fy",
                            "parkList": [
                                {
                                    "parkCode": "2342LKM",
                                    "parkName": "开发测试车场"
                                }
                            ],
                            "sellBillId": 5274,
                            "serialNumber": "BWQMJ1O4S3R27FK",
                            "status": 0,
                            "traderName": "fy",
                            "validTo": "20210609104815"
                        }
                    ],
                    "total": 1
                },
                "message": "业务成功",
                "resultCode": 0,
                "status": 1
            }
,
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台 查询电子券售卖记录",
                t_url: this.commonUrls.test+"queryTraderCouponSellRecord",
                p_url: this.commonUrls.prod+"queryTraderCouponSellRecord",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCodeList', info2: '是', info3: 'JSONArray', info4: '停车场编号列表' },
                        { info1: 'sellBeginTime', info2: '是', info3: 'String', info4: '发放起始时间，yyyyMMddHHmmss' },
                        { info1: 'sellEndTime', info2: '是', info3: 'String', info4: '发放结束时间，yyyyMMddHHmmss' },
                     { info1: 'pageNum', info2: '否', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '否', info3: 'Integer', info4: '每页多少条，最多100条' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'sellBillId', info2: '是', info3: 'Long', info4: '售卖id' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠券名称' },
                        { info1: 'traderName', info2: '是', info3: 'String', info4: '商家名称' },
                        { info1: 'traderId', info2: '是', info3: 'Long', info4: '商家ID' },
                        { info1: 'couponTmpId', info2: '是', info3: 'String', info4: '券模板id' },
                        { info1: 'sellNum', info2: '是', info3: 'String', info4: '售卖数量' },
                        { info1: 'grantNum', info2: '是', info3: 'String', info4: '发放数量' },
                        { info1: 'remainNum', info2: '是', info3: 'Decimal', info4: '剩余数量' },
                        { info1: 'usedNum', info2: '是', info3: 'Long', info4: '已使用数量' },
                        { info1: 'sellTime', info2: '是', info3: 'String', info4: '售卖时间，yyyyMMddHHmmss' },
                        { info1: 'grantValidTo', info2: '是', info3: 'String', info4: '发放有效期至，yyyyMMddHHmmss' },
                        { info1: 'sellRemark', info2: '否', info3: 'JSONArray', info4: '售卖备注' },
                        { info1: 'refundNum', info2: '否', info3: 'Integer', info4: '退费数量' },
                        { info1: 'refundTime', info2: '否', info3: 'String', info4: '退费时间' },
                        { info1: 'refundMoney', info2: '否', info3: 'BigDecimal', info4: '退费金额' },
                        { info1: 'refundRemark', info2: '否', info3: 'String', info4: '退费备注' },
                        { info1: 'transactionNum', info2: '否', info3: 'String', info4: '交易单号' },
                        { info1: 'thirdTransactionNum', info2: '否', info3: 'String', info4: '第三方交易单号' }
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/queryTraderCouponSellRecord.vue